const isScorePlaceHolderSelection = (focusBlock) => {
  if (
    focusBlock &&
    focusBlock.type.indexOf('_cgpa_max') === '-1' &&
    focusBlock.text
  ) {
    return true;
  }

  return false;
};

export default ({
  value,
  bold,
  italic,
  underline,
  unorderedList,
  comment,
  setMarkType,
}) => {
  // Format Bold and Italic Marks
  const marks = {
    bold: false,
    italic: false,
    underline: false,
    unorderedList: false,
    comment: false,
  };
  if (
    value?.selection?.isFocused &&
    !isScorePlaceHolderSelection(value.focusBlock) &&
    value?.activeMarks?.size > 0
  ) {
    value.activeMarks.forEach(({ type }) => {
      if (type in marks) {
        marks[type] = true;
      }
    });
  }

  const { focusBlock, document } = value;
  if (focusBlock) {
    const { type: focusBlockType, key: focusBlockKey } = focusBlock;
    if (focusBlockType === 'paragraph') {
      const parentBlock = document.getParent(focusBlockKey);
      if (parentBlock) {
        const { type: parentBlockType, key: parentBlockKey } = parentBlock;
        if (parentBlockType === 'list_item') {
          const grandParent = document.getParent(parentBlockKey);
          if (grandParent) {
            const { type: grandParentType } = grandParent;
            if (grandParentType === 'unordered_list') {
              marks.unorderedList = true;
            }
          }
        }
      }
    }
  }

  if (
    (setMarkType && bold !== marks.bold) ||
    italic !== marks.italic ||
    underline !== marks.underline ||
    (unorderedList && unorderedList !== marks.unorderedList) ||
    comment !== marks.comment
  ) {
    setMarkType({ ...marks });
    return true;
  }

  return false;
};
